<template>
	<div class="ng-scope show-sticky-calc" :class="openModal ? 'modal-open' : ''">
		<headerNavigation :isHome="true" @openLoginMadal="openLoginMadal" @changeRegister="changeRegister"></headerNavigation>
		<template v-if="isMobile">
			<div class="global-header-spacer display-mobile" style="height: 0px;" ></div>
			<div class="div-after-fixed-header" style="height: 103px;"></div>
		</template>
		<div class="page-content-container">
			<div class="breadcrumb-container container ">
				<div class="row">
					<div class="col-xs-24">
						<div class="comp-breadcrumbs-container">
							<ul class="breadcrumbs-list clearfix breadcrumbs-not-empty">
								<li class="breadcrumb-list-item active">
									<a href="javascript:void()" @click="openPage('/')" class="site-secondary-link breadcrumb-link breadcrumb1">{{$t('common.home')}}</a>
								</li>
								<li class="breadcrumb-list-item ">
									<span class="breadcrumb-active-label breadcrumb2">{{$t('footer.contactus')}}</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="page-static-container container">
				<div class="content-static-region">
					<div class="article-info">
						<div class="content-area-infos">
							<h1 class="heading ">{{infos.title}}</h1>
							<p class="text">
								{{infos.subheading}}
							</p>
							<img :src="infos.img" class="banner" v-if="infos.img"/>
						</div>
					</div>
					<div class="comp-contact-us-container col-sm-offset-2 col-sm-20">
						<div class="panel panel-default">
							<div class="panel-heading">
								<img src="../../assets/images/email.png" class="email-icon"/>
								<span class="contact-us-panel-heading">{{$t('contactus.header')}}</span>
							</div>
							<div class="panel-body">
								<div class="ng-isolate-scope">
									<div class="comp-contact-us-form-container">
										<div class="contact-us-form">
											<div class="name-phone-row row ng-scope">
												<div class="name-column col-sm-8">
													<div class="site-form-group form-group">
														<div class="input-label-container">
															<span class="site-input-label">*{{$t('login.name')}}:</span>
														</div>
														<div class="site-input-group">
															<input type="text" v-model="name" class="site-form-input form-control" autocomplete="off" maxlength="20" :placeholder="$t('login.name')">
														</div>
													</div>
												</div>
												<div class="phone-column col-sm-8">
													<div class="site-form-group form-group">
														<div class="input-label-container">
															<span class="site-input-label">*{{$t('address.phone')}}:</span>
														</div>
														<div class="site-input-group">
															<input type="text" v-model="mobile" class="site-form-input form-control " autocomplete="off" placeholder="(000)000-0000" maxlength="14" >
														</div>
													</div>
												</div>
												<div class="col-sm-8">
													<div class="site-form-group form-group">
														<div class="site-form-group form-group">
															<div class="input-label-container">
																<span class="site-input-label">{{$t('login.companyname')}}:</span>
															</div>
															<div class="site-input-group">
																<input type="text" v-model="companyname" class="site-form-input form-control" autocomplete="off" maxlength="50" :placeholder="$t('login.companyname')">
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="email-row row ng-scope">
												<div class="col-sm-12">
													<div class="site-form-group form-group">
														<div class="input-label-container">
															<span class="site-input-label">*{{$t('login.email')}}:</span>
														</div>
														<div class="site-input-group">
															<input type="text" v-model="email" class="site-form-input form-control" autocomplete="off" maxlength="50" :placeholder="$t('login.email')">
														</div>
													</div>
												</div>
											</div>
											<div class="message-row">
												<div class="site-form-group form-group">
													<div class="site-input-group">
														<textarea v-model="content" class="message-textarea site-form-input form-control form-textarea" :placeholder="$t('contactus.message')"></textarea>
													</div>
												</div>
											</div>
											<div class="submit-btn-container">
												<button @click="doConfirm" class="ng-not-empty ng-valid" :class="isLoading ? 'site-btn-primary-disabled' : ''">
													<img src="../../assets/images/loading.png" class="loader-icon fa fa-spinner fa-spin ng-star-inserted loading-icon" v-if="isLoading"/>
													{{$t('contactus.send')}}
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footers></footers>
		<loginModal ref="loginRef" :isShow="showLoginModal" @closeLoinMadal="closeLoinMadal"></loginModal>
		<div v-if="openModal" class="modal-backdrop fade ng-scope in" style="z-index: 1040;"></div> 
	</div>
</template>

<script>
import headerNavigation from '../../components/headerNavigation.vue'
		import footers from '../../components/footers.vue'
		import loginModal from '../../components/loginModal.vue'
		import {getArticle,confrimContactUs} from '../../api/api.js'
		export default {
			components: {
				headerNavigation,
				footers,
				loginModal
			},
			data() {
				return {
					isMobile: false,
					showLoginModal: false,
					contents:``,
					openModal:false,
					isLoading:false,
					email:'',
					mobile:'',
					companyname:'',
					content:'',
					name:'',
					infos:{}
				};
			},
			created() {
				this.isMobile = this.webIsMobile()
				this.init()
			},
			methods: {
				init(){
					var that = this;
					let params = {
						type:11
					}
					getArticle(params).then(res => {
						if (res.code == 200) {
							that.infos = res.data
						}
					})
				},
				openLoginMadal() {
					this.showLoginModal = true
					this.changeRegister(false)
				},
				closeLoinMadal() {
					this.showLoginModal = false
				},
				changeRegister(e) {
					this.$refs.loginRef.changeRegisterType(e)
					this.showLoginModal = true
				},
				verification() {
					if(!this.name){
						this.$message.warning(this.$t('tips.pleaseinputname'));
						return false;
					}
					if(!this.mobile){
						this.$message.warning(this.$t('tips.pleaseinputmobile'));
						return false;
					}
					if(!this.email){
						this.$message.warning(this.$t('tips.pleaseinputemail'));
						return false;
					}
					if(!this.content){
						this.$message.warning(this.$t('tips.pleaseinputmessage'));
						return false;
					}
					return true;
				},
				doConfirm(){
					if(this.verification()){
						var that = this;
						let params = {
							email:this.email,
							mobile:this.mobile,
							content:this.content,
							name:this.name,
							companyname:this.companyname
						}
						that.isLoading = true
						confrimContactUs(params).then(res => {
							that.isLoading = false
							if (res.code == 200) {
								that.$message.success(res.msg);
							}else{
								that.$message.warning(res.msg);
								return false;
							}
							
						})
					}
				}
			}
		}
</script>

<style scoped>
	.global-header-spacer {
	    height: 60px !important;
	    display: block !important;
	}
	.page-static-container .comp-contact-us-container .panel-heading {
	    padding: 10px 20px;
	}
	.page-static-container .comp-contact-us-container .panel-heading .email-icon {
		width: 18px;
		height: 18px;
	}
	.page-static-container .comp-contact-us-container .panel-body {
	    padding: 20px;
	}
	.page-static-container .comp-contact-us-container .submit-btn-container {
	    text-align: right;
	    margin-top: 10px;
	}
	.page-static-container .comp-contact-us-container .submit-btn-container button {
	    min-width: 150px;
	}
	.message-textarea {
		height: 115px;
	}
</style>